import {Col, DatePicker, Form, Input, Row, Select} from 'antd';
import React from 'react';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';
import AddFormComponent from '../common/AddFormComponent';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';
import SaveButtonComponent from '../common/SaveButtonComponent';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const AddMeetingDetail = () => {
	const currentUrl = window.location.href;
	const apiList = [Arguments.host + '/society_organization/policy/api!addMeetingMember.do'];

	return (
		currentUrl.endsWith('add') ? <AddFormComponent UserForm={MeetingDetailForm} url={apiList}/> :
			<EditFormComponent UserForm={MeetingDetailForm} url={apiList}/>
	);
};

const MeetingDetailForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 800, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="memberName" label="姓名" rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="memberSex" label="性别" rules={[{required: true, message: '内容不能为空'}]}>
						<Select>
							<Select.Option value="男">男</Select.Option>
							<Select.Option value="女">女</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="memberMz" label="民族" rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="memberBorn" label="出生日期" rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="memberEducational" label="文化程度"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="memberZzmm" label="政治面貌" rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="中共党员">
						<Select>
							<Select.Option value="中共党员">中共党员</Select.Option>
							<Select.Option value="中共预备党员">中共预备党员</Select.Option>
							<Select.Option value="共青团员">共青团员</Select.Option>
							<Select.Option value="民革党员">民革党员</Select.Option>
							<Select.Option value="民盟盟员">民盟盟员</Select.Option>
							<Select.Option value="民建会员">民建会员</Select.Option>
							<Select.Option value="民进会员">民进会员</Select.Option>
							<Select.Option value="农工党党员">农工党党员</Select.Option>
							<Select.Option value="致公党党员">致公党党员</Select.Option>
							<Select.Option value="九三学社社员">九三学社社员</Select.Option>
							<Select.Option value="台盟盟员">台盟盟员</Select.Option>
							<Select.Option value="无党派人士">无党派人士</Select.Option>
							<Select.Option value="群众">群众</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="memberPost" label="社团职务" rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="memberUnit" label="工作单位" rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="organizationPost" label="职务"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="memberProfessional" label="职称"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="memberSfz" label="身份证号"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="mobilePhone" label="手机电话"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<SaveButtonComponent/>
			</Form.Item>
		</Form>
	);
};

export default AddMeetingDetail;
